import { render, staticRenderFns } from "./WaterList.vue?vue&type=template&id=1c4ffc13&scoped=true"
import script from "./WaterList.vue?vue&type=script&lang=js"
export * from "./WaterList.vue?vue&type=script&lang=js"
import style0 from "./WaterList.vue?vue&type=style&index=0&id=1c4ffc13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ffc13",
  null
  
)

export default component.exports